module.exports = __webpack_public_path__ + "img/elo.5df75a4b.png";